import React from "react";

import LogoLoadingStill from "@src/sharedComponents/LogoLoadingStill/LogoLoadingStill";
import Switch from "@src/sharedComponents/Switch/Switch";
import FullDataTable from "@src/sharedComponents/Table/FullDataTable";
import { Cell, Row } from "@src/sharedComponents/Table/Types";

import Footer from "./Footer";
import Header from "./Header";
import { DoNotSellColumns } from "./hooks/useDoNotSellTableData";

import styles from "./DoNotSellModal.module.css";

interface Props {
  isMutating: boolean;
  closeModal: () => void;
  onConfirm: () => void;
  rows: Row<DoNotSellColumns, Cell>[];
  columns: NonEmptyArray<DoNotSellColumns>;
  numberOfChanges: number;
  tradingGroupName: string;
  markAllSecurities: () => void;
  unmarkAllSecurities: () => void;
  inputValue: string;
  setInputValue: (value: string) => void;
}
const DoNotSellModal: React.FC<Props> = ({
  closeModal,
  isMutating,
  onConfirm,
  tradingGroupName,
  rows,
  columns,
  numberOfChanges,
  markAllSecurities,
  unmarkAllSecurities,
  inputValue,
  setInputValue,
}) => {
  return (
    <>
      <Header
        tradingGroupName={tradingGroupName}
        markAllSecurities={markAllSecurities}
        unmarkAllSecurities={unmarkAllSecurities}
        inputValue={inputValue}
        setInputValue={setInputValue}
      />
      <div className={styles.tableWrapper}>
        <FullDataTable<DoNotSellColumns, Cell>
          key={inputValue} // Force table reset when search changes
          noBorderRadius
          showEmptyRows
          useQueryParams={false}
          scrollable={false}
          columns={columns}
          rows={rows}
          emptyCell={<Switch onClick={() => {}} on={false} disabled={true} />}
          defaultRowsPerPage={10}
          defaultSortColumn={["Do not sell", "desc"]}
          disableColumnSorting={["Do not sell"]} // we don't want any initial column sort, so this is the easiest way to do it without changing the table component
        />
      </div>
      <Footer
        numberChanges={numberOfChanges}
        isMutating={false}
        onCloseModal={closeModal}
        onConfirm={onConfirm}
      />
      {isMutating && (
        <div className={styles.loadingContainer}>
          <LogoLoadingStill onTop />
        </div>
      )}
    </>
  );
};

export default DoNotSellModal;
